module.exports = __webpack_public_path__ + "0d2b7f68bf21351978027d44415baf61.pdf";